import { LogOut, Menu, Search } from "lucide-react";
import RoleBadge from "./RoleBadge";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import NotificationDropdown from "../Notifikasi/NotificationDropdown";

export default function Navbar({ onMobileMenuOpen }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header
      data-testid="top-navbar"
      className="fixed left-0 right-0 top-0 z-30 h-16 border-b border-blue-100/60 backdrop-blur-sm md:left-64 print:hidden"
      style={{ background: "linear-gradient(90deg, #eff6ff 0%, #f0f9ff 55%, #fdf4ff 100%)" }}
    >
      <div className="flex h-full items-center justify-between px-4 md:px-8">
        {/* Left: mobile menu + search */}
        <div className="flex items-center gap-3 flex-1">
          <button
            type="button"
            className="rounded-lg border border-blue-200/50 p-2 text-blue-600/70 hover:bg-white/80 md:hidden transition-colors"
            onClick={onMobileMenuOpen}
            data-testid="mobile-menu-btn"
            aria-label="Buka menu"
          >
            <Menu className="h-5 w-5" />
          </button>

          {/* Search bar */}
          <div className="relative hidden md:flex items-center max-w-sm w-full">
            <Search className="absolute left-3 h-4 w-4 text-slate-400 pointer-events-none" strokeWidth={2} />
            <input
              type="text"
              placeholder="Cari program, tugas, laporan..."
              className="w-full pl-9 pr-4 py-2 text-[13px] bg-white/70 border border-blue-100 rounded-xl focus:outline-none focus:border-blue-300 focus:ring-2 focus:ring-blue-100 text-slate-700 placeholder-slate-400 transition-all"
            />
          </div>
        </div>

        {/* Right: notifications + user */}
        <div className="flex items-center gap-2 md:gap-3">
          <NotificationDropdown />

          <div className="h-8 w-px bg-blue-200/40 mx-1" />

          {/* User info */}
          <div className="flex items-center gap-2.5">
            <div
              className="flex h-9 w-9 items-center justify-center rounded-full text-white text-[13px] font-bold shadow-sm"
              style={{ background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)" }}
            >
              {user?.name?.charAt(0)?.toUpperCase() || "?"}
            </div>
            <div className="hidden text-left leading-tight sm:block">
              <div
                className="max-w-[160px] truncate text-[13px] font-semibold text-slate-800"
                data-testid="navbar-user-name"
                title={user?.name}
              >
                {user?.name || "—"}
              </div>
              <div className="mt-0.5 flex items-center gap-1.5">
                {user?.role ? <RoleBadge role={user.role} /> : null}
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={handleLogout}
            data-testid="logout-btn"
            className="inline-flex items-center gap-1.5 rounded-xl border border-blue-200/60 bg-white/60 px-3 py-1.5 text-[12px] font-semibold text-slate-600 transition-all hover:border-[#1e3a5f] hover:bg-white hover:text-[#1e3a5f] backdrop-blur-sm"
          >
            <LogOut className="h-3.5 w-3.5" strokeWidth={2.2} />
            <span className="hidden sm:inline">Keluar</span>
          </button>
        </div>
      </div>
    </header>
  );
}
